<template>
  <main class="campaign-extensions" :class="{ 'with-preview': !!selectedExtension }">
    <sb-async-dropdown
      class="extension-dropdown"
      :rows="extensionsDropdown.rows"
      :options="extensionsDropdown.options"
      :focused.sync="extensionsDropdown.focused"
      :selected="selectedExtension"
      @update:selected="clickedExtension"
    >
      <template #label>
        <template v-if="!selectedExtension">
          <span class="add-extension-label">+ add extension</span>
        </template>
        <template v-else>
          <a @click.stop="clickedCancel()" class="delete-extension">&times;</a>
          <a @click.stop="showingModal = selectedExtension.state" class="edit-extension">
            <span>{{ selectedExtension.state.label }}</span>
            <span class="edit-button">edit</span>
          </a>
        </template>
      </template>
    </sb-async-dropdown>

    <template v-if="showingModal">
      <any-link-modal
        v-if="showingModal.type === 4"
        :campaign="campaign"
        :extension="showingModal"
        @closeModal="closeModalAndResetExtensionIfNoPayload"
      />

      <bonus-points-modal
        v-if="showingModal.type === 5"
        :campaign="campaign"
        :extension="showingModal"
        @closeModal="closeModalAndResetExtensionIfNoPayload"
      />

      <digital-voucher-modal
        v-if="showingModal.type === 1"
        :campaign="campaign"
        :extension="showingModal"
        @closeModal="closeModalAndResetExtensionIfNoPayload"
      />

      <instant-points-modal
        v-if="showingModal.type === 6"
        :campaign="campaign"
        :extension="showingModal"
        @resolve="didResolveModal"
        @reject="didRejectModal"
      />

      <target-wallet-modal
        v-if="showingModal.type === 3"
        :campaign="campaign"
        :extension="showingModal"
        @update:campaign="$emit('update:campaign', $event)"
        @closeModal="closeModalAndResetExtensionIfNoPayload"
      />
    </template>
    <template v-if="selectedExtension">
      <any-link-preview
        v-if="selectedExtension.state.type === 4"
        :extension="selectedExtension.state"
      />

      <bonus-points-preview
        v-if="selectedExtension.state.type === 5"
        :extension="selectedExtension.state"
      />

      <digital-voucher-preview
        v-if="selectedExtension.state.type === 1"
        :extension="selectedExtension.state"
      />

      <instant-points-preview
        v-if="selectedExtension.state.type === 6"
        :payload="selectedExtension.state.payload"
      />

      <target-wallet-preview
        v-if="selectedExtension.state.type === 3"
        :extension="selectedExtension.state"
      />
    </template>
  </main>
</template>

<script>
import AnyLinkModal from "./any-link-modal";
import AnyLinkPreview from "./any-link-preview";
import BonusPointsModal from "./bonus-points-modal";
import BonusPointsPreview from "./bonus-points-preview";
import DigitalVoucherModal from "./digital-voucher-modal";
import DigitalVoucherPreview from "./digital-voucher-preview";
import InstantPointsModal from "./instant-points-modal";
import InstantPointsPreview from "./instant-points-preview";
import TargetWalletModal from "./target-wallet-modal";
import TargetWalletPreview from "./target-wallet-preview";
import { campaignAPI } from "./../../../services/api/campaignAPI";
import { anylinkAPI } from "./../../../services/api/anylinkAPI"
import { rewardAPI } from "./../../../services/api/rewardAPI";

export default {
  props: {
    campaign: Object
  },

  name: "campaign-extensions",

  components: {
    AnyLinkModal,
    AnyLinkPreview,
    BonusPointsModal,
    BonusPointsPreview,
    DigitalVoucherModal,
    DigitalVoucherPreview,
    InstantPointsModal,
    InstantPointsPreview,
    TargetWalletModal,
    TargetWalletPreview
  },

  data: () => {
    return {
      anylinks: null,
      extensionsDropdown: {
        rows: [
          { slot: 'select-row',
            state: {
              type: 1,
              label: "digital voucher",
              payload: null
            }
          },
          { slot: 'select-row',
            state: {
              type: 5,
              label: "bonus points",
              payload: null
            }
          },
          { slot: 'select-row',
            state: {
              type: 6,
              label: "instant points",
              payload: null
            }
          },
          { slot: 'select-row',
            state: {
              type: 3,
              label: "target wallet",
              payload: null
            }
          },
          { slot: 'select-row',
            state: {
              type: 4,
              label: "any link",
              payload: null
            }
          }
        ],
        selected: null,
        focused: false,
        options: {
          label: () => {}
        }
      },
      reward: null,
      selectedExtension: null,
      hasPreloadImage: false,
      hasCouponImage: false,
      showingModal: null //This hold the extension row we want to switch to
    }
  },

  async created() {
    if(!this.campaign.reward_id) {
      const { reward } = await rewardAPI.create(this.campaign.id, "Campaign");
      this.reward = reward;
      this.campaign.reward_id = reward.id;
    }else{
      const { reward } = await rewardAPI.fetch(this.campaign.reward_id, this.campaign.id, 'Campaign');
      this.reward = reward;

      await this.$store.dispatch('UPDATE_VALUES', { reward });
      await this.$store.dispatch('VALIDATE', ['reward']);
      await this.$store.dispatch('TOUCH_FIELDS', ['reward']);
    }
    this.anylinks = await campaignAPI.getAnyLinks(this.campaign.id);
    const extensionType = this.campaign.extension_type;
    if(extensionType !== 0){
      this.selectedExtension = this.extensionsDropdown.rows.find(extension => extension.state.type === extensionType);
      this.selectedExtension.state.payload = this.getPayload(this.selectedExtension.state);
    }
  },

  methods: {
    clickedCancel() {
      this.selectedExtension = null;
      this.$emit("update:campaign", { _type: 0 });
    },

    clickedExtension(_newExtension) {
      const newExtension = { ..._newExtension }; //We make a copy since we add the payload to it later but use the payload for criteria in workflow

      if(this.shouldShowModal(newExtension)) {
        newExtension.payload = this.getPayload(newExtension);
        this.showingModal = newExtension;
      } else {
        this.selectedExtension = this.extensionsDropdown.rows.find(extension => extension.state.type === newExtension.type);

        if(this.selectedExtension.state.type === 1 || this.selectedExtension.state.type === 5) {
          this.selectedExtension.state.payload.has_preload_image = this.hasPreloadImage
        }

        this.updateReward(newExtension.payload);
        this.$emit("update:campaign", { _type: newExtension.type });
      }
    },


    async didResolveModal(payload) {
      await this.updateReward(payload);

      this.selectedExtension = this.extensionsDropdown.rows.find(extension => extension.state.type === this.showingModal.type);
      this.selectedExtension.state.payload = payload;
      this.showingModal = null;

      this.$emit("update:campaign", { _type: this.selectedExtension.state.type });
    },

    async didRejectModal() {
      this.showingModal = null;
    },

    async updateReward(payload) {
      await rewardAPI.patchRewards(this.campaign.reward_id, {
        owner_id: this.campaign.id,
        owner_type: 'Campaign',
        reward: payload
      });
    },

    closeModalAndResetExtensionIfNoPayload() {
      if(!this.shouldResetExtension(this.showingModal)) {
        //It was "resolved"
        this.selectedExtension = this.extensionsDropdown.rows.find(extension => extension.state.type === this.showingModal.type);
        this.selectedExtension.state = this.showingModal;

        if(this.selectedExtension.state.type === 1 || this.selectedExtension.state.type === 5) {
          this.hasPreloadImage = this.selectedExtension.state.payload.has_preload_image
        }

        this.$emit("update:campaign", { _type: this.selectedExtension.state.type });
      }

      this.showingModal = null;
    },

    isReward(newExtension) {
      return [1, 5, 6].includes(newExtension.type);
    },

    getPayload(extension){
      if(this.isReward(extension)) {
        return this.reward;
      } else if(extension.type === 3){
        return this.campaign.wallet_target;
      } else if(extension.type === 4){
        return this.anylinks;
      }
    },

    shouldResetExtension(selectedExtension){
      if(this.isReward(selectedExtension) && !selectedExtension.payload?.item_name) {
        return true;
      } else if(selectedExtension.type === 4 && selectedExtension.payload?.length === 0) {
        return true;
      } else if(selectedExtension.type === 3 && !selectedExtension.payload) {
        return true;
      }
      return false;
    },

    shouldShowModal(newExtension) {
      if(!newExtension) {
        return false;
      }else{
        if((this.isReward(newExtension) && !newExtension.payload) ||
           (newExtension.type === 4 && (!Array.isArray(newExtension.payload) || newExtension.payload.length === 0)) ||
           (newExtension.type === 3 && newExtension.payload === null)) {
          return true;
        } else {
          return false
        }
      }
    },
  }
}
</script>

<style scoped>
.campaign-extensions {
  background-color: white;
  display: flex;
  flex-flow: row nowrap;
  font-family: "AileronLight";
  margin-top: 20px;
  position: relative;

}

.add-extension-label {
  font-family: AileronThin;
}

.campaign-extensions.with-preview {
  border: 1px solid #128ff9;
  border-left: 0;
  border-radius: 16px;
}

.extension-dropdown {
  margin-bottom: 0
}

.campaign-extensions .extension-dropdown >>> .label-container {
  align-items: center;
  background-color: #128ff9;
  border-radius: 16px;
  color: white;
  display: flex;
  font-size: 18px;
  min-height: 100px;
  height: 100%;
  justify-content: center;
  min-width: 153px;
  padding: 14px;
}

.campaign-extensions .extension-dropdown >>> .sb-content {
  text-align: center;
  color: #128ff9;
  border-width: 0px 1px 1px 1px;
  border-bottom-right-radius: 16px;
  border-bottom-left-radius: 16px;
  border-style: solid;
  border-color: #128ff9;
  margin-top: -15px;
  padding: 15px 0 0 0;
  background-color: transparent;
}

.campaign-extensions .extension-dropdown >>> .sb-footer {
  padding: 0;
}

.campaign-extensions .extension-dropdown >>> .sb-content-items {
  border-bottom-right-radius: 16px;
  border-bottom-left-radius: 16px;
}

.campaign-extensions .extension-dropdown >>> .sb-content-items .dropdown-item:last-of-type{
  padding-bottom: 15px;
}

.campaign-extensions .extension-dropdown .delete-extension {
  position: absolute;
  top: 0;
  left: 5px;
  font-size: 1.125em;
}

.campaign-extensions .extension-dropdown .edit-extension span {
  display: block;
  line-height: 20px;
  text-align: center;
}

.campaign-extensions .extension-dropdown .edit-button {
  font-size: .83em;
}

.campaign-extensions .extension-dropdown a {
  color: white;
}

.campaign-extensions .extension-dropdown .icon-container {
  display: none;
}
</style>
